// extracted by mini-css-extract-plugin
export default {"title":"Tabtitle_title__JpYe5","tabs__btn":"Tabtitle_tabs__btn__VDzuz","tabs__btn_active":"Tabtitle_tabs__btn_active__z89CA"};